
export const ITEM_TYPE = {
  EVENT: 'EVENT',
  SERIES: 'SERIES',
};

export const ELIGIBILITY = {
  F2F_EXCHANGE: 'F2F_EXCHANGE',
};
